import React from 'react';

export const Explanation = <>
  Lexery is a fast paced word game.
</>

export const HowToPlay = <>
  Add, remove, or replace a letter to form another word.
</>

export const HowToAcceptHint = <>
  Hit <kbd>Enter</kbd> to accept a word.
</>

export const UseOnceRule = <>
  You can only use each word once.
</>

export const ValidWordRule = <>
  Words must be in the dictionary.
</>

export const ValidWordHint = <>
  Words must be in the dictionary, hit <kbd>Esc</kbd> to reset.
</>

export const DifferenceRule = <>
  Words can only differ by one letter.
</>

